import React, { useRef, useEffect } from 'react';
import { Editor } from 'draft-js';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import EditorToolbar from './components/EditorToolbar/EditorToolbar';
import {
  onBeforeInput,
  onKeyCommand,
  onPastedText,
  onReturn,
} from '../utils/handlers';
import ChangeEditorLinkModal from './components/ChangeEditorLinkModal/ChangeEditorLinkModal';
import { getBlockStyle } from '../utils/getBlockStyle';
import { resetBlockType } from '../utils/resetBlockType';
import styles from './MessageEditor.module.scss';
import ChangeEditorPhoneModal from './components/ChangeEditorPhoneModal/ChangeEditorPhoneModal';
import {
  phoneAdd,
  linkAdd,
  homePhoneAdd,
  informationsLinkAdd,
} from '../constans/controlToolbar';
import ChangeEditorInformationsLinkModal from './components/ChangeEditorInformationsLinkModal/ChangeEditorInformationsLinkModal';

//editor - обьект с двумя полями:
//editorStateSelector - получение состояния редактора
//setEditorState - action для изменения состояния редактора

//toolbarCreate - массив для передачи в тулбар необходимых фич

//closeEditor - обьект с двумя полями:
//closeBtn - булевое значение кнопки закрытия, нужна или нет
//setCloseEditor - action для закрытия редактора

//linkModal - обьект с двумя полями:
//setEditorLinkModalData - action для изменения сосотояния модалки ссылок
//editorLinkModalDataSelector - получение обьекта модалки для ссылок

//phoneModal - обьект с двумя полями:
//editorPhoneModalDataSelector - получение обьекта модалки для телефона
//setEditorPhoneModalData - action для изменения сосотояния модалки телефона

const MessageEditor = ({
  className,
  editor,
  closeEditor = { setCloseEditor: null, closeBtn: false },
  toolbarCreate = [],
  linkModal = { setEditorLinkModalData: null },
  phoneModal = { setEditorPhoneModalData: null },
  linkInformationModal = { setEditorInformationLinkModalData: null },
  appSectionsList = [],
}) => {
  const { editorStateSelector, setEditorState } = editor;
  const { closeBtn, setCloseEditor } = closeEditor;
  const { setEditorLinkModalData } = linkModal;
  const { setEditorPhoneModalData } = phoneModal;
  const { setEditorInformationLinkModalData } = linkInformationModal;

  const dispatch = useDispatch();

  const editorRef = useRef();
  const editorState = useSelector(editorStateSelector);

  const handleChange = (newEditorState) => {
    if (!newEditorState.getCurrentContent().hasText()) {
      newEditorState = resetBlockType(newEditorState);
    }

    dispatch(setEditorState(newEditorState));
  };

  const handleKeyCommand = (command, editorState) =>
    onKeyCommand({ command, editorState, onChange: handleChange });

  const handleReturn = (_e, editorState) => onReturn(editorState, handleChange);

  const handleBeforeInput = (chars, editorState) =>
    onBeforeInput({ chars, editorState, onChange: handleChange });

  const handlePastedText = (_text, html, editorState) =>
    onPastedText({ html, editorState, onChange: handleChange });

  const handleClose = () => {
    dispatch(setCloseEditor(false));
  };

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
  }, []);

  return (
    <div className={cn(styles.root, className)}>
      <EditorToolbar
        onChange={handleChange}
        onClose={handleClose}
        className={styles.toolbar}
        toolbarCreate={toolbarCreate}
        editorStateSelector={editorStateSelector}
        closeBtn={closeBtn}
        setEditorLinkModalData={setEditorLinkModalData}
        setEditorPhoneModalData={setEditorPhoneModalData}
        setEditorInformationLinkModalData={setEditorInformationLinkModalData}
      />
      <div className={styles.editorWrap}>
        <Editor
          editorState={editorState}
          onChange={handleChange}
          handleKeyCommand={handleKeyCommand}
          handleReturn={handleReturn}
          handlePastedText={handlePastedText}
          handleBeforeInput={handleBeforeInput}
          ref={editorRef}
          blockStyleFn={getBlockStyle}
        />
      </div>
      <>
        {toolbarCreate
          ? toolbarCreate.map((type) => {
              if (type === linkAdd) {
                return (
                  <ChangeEditorLinkModal
                    key={linkAdd}
                    editorState={editorState}
                    editor={editor}
                    linkModal={linkModal}
                  />
                );
              }
              if (type === informationsLinkAdd) {
                return (
                  <ChangeEditorInformationsLinkModal
                    key={informationsLinkAdd}
                    editorState={editorState}
                    editor={editor}
                    linkInformationModal={linkInformationModal}
                    appSectionsList={appSectionsList}
                  />
                );
              }
              if (type === phoneAdd) {
                return (
                  <ChangeEditorPhoneModal
                    key={phoneAdd}
                    editorState={editorState}
                    editor={editor}
                    phoneModal={phoneModal}
                  />
                );
              }
            })
          : null}
      </>
    </div>
  );
};

export default MessageEditor;
